import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createUser } from '../index';
export const useCreateUser = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createUser, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetUsers');
            setAction({
                type: 'success',
                message: 'Creating the user was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
